import React from 'react';
import Loader from "react-loader";

export const ProgressLoader = (props) => {

    const loaderSize = props.md ? { scale: 0.7, position: 'relative', color: props.color } : (props.sm ? { scale: 0.4, position: 'relative', color: props.color } : {});

    return (
        <Loader options={loaderSize} />
    );
}